import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout/index.vue'
import { warningClose } from '@/utils/message'
import { updateShareMeta } from '@/utils/updateShareMeta'

Vue.use(VueRouter)

const routes = [
  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ "@/views/user/login/Login.vue")
  },
  // 注册
  {
    path: "/register/:id",
    name: "register",
    component: () => import(/* webpackChunkName: "register" */ "@/views/user/register/Register.vue")
  },
  // 绑定微信
  {
    path: "/loginAndbindAccount",
    name: "bindWx",
    component: () => import(/* webpackChunkName: "bindWx" */ "@/views/user/bindWx/BindWx.vue")
  },
  // 经典实践 - 不用登陆
  {
    path: "/insidePlist",
    name: 'insidePlist',
    component: () => import(/* webpackChunkName: "insidePlist" */ "@/views/product/list/insidePlist.vue"),
    meta: {
      keepAlive: true
    }
  },
  // 翻译序列号
  {
    path: "/s",
    name: 'serialNumber',
    component: () => import("@/views/serialNumber/serialNumber.vue"),
    meta: {
      notVisibleTool: true,
    }
  },
  {
    path: '/',
    name: '',
    component: layout,
    redirect: '/home',
    children: [
      // 首页
      {
        path: "/home",
        name: "home",
        component: () => import(/* webpackChunkName: "HomeView" */ "@/views/home/HomeView.vue")
      },
      // 解决方案 - 暂时弃用(产品介绍)
      {
        path: "/product",
        name: 'product',
        component: () => import("@/views/product/index.vue"),
        children: [
          // 干部管理
          {
            path: "cadreInformation",
            name: 'cadreInformation',
            component: () => import(/* webpackChunkName: "cadreInformation" */ "@/views/product/cadreInformation.vue"),
            meta: {
              name: '干部信息'
            }
          },
          // 领导桌面 
          {
            path: "leaderDesktop",
            name: 'leaderDesktop',
            component: () => import(/* webpackChunkName: "leaderDesktop" */ "@/views/product/leaderDesktop.vue"),
            meta: {
              name: '领导桌面'
            }
          },
          // 员工自助
          {
            path: "employeeSelfService",
            name: 'employeeSelfService',
            component: () => import(/* webpackChunkName: "employeeSelfService" */ "@/views/product/employeeSelfService.vue"),
            meta: {
              name: '员工自助'
            }
          },
          // 绩效管理
          {
            path: "performanceManagement",
            name: 'performanceManagement',
            component: () => import(/* webpackChunkName: "performanceManagement" */ "@/views/product/performanceManagement.vue"),
            meta: {
              name: '绩效管理'
            }
          },
          // 职称评审
          {
            path: "titleReview",
            name: 'titleReview',
            component: () => import(/* webpackChunkName: "titleReview" */ "@/views/product/titleReview.vue"),
            meta: {
              name: '职称评审'
            }
          },
          // 人才培养
          {
            path: "onlineLearning",
            name: 'onlineLearning',
            component: () => import(/* webpackChunkName: "onlineLearning" */ "@/views/product/onlineLearning.vue"),
            meta: {
              name: '在线学习'
            }
          },
          // 人才引进
          {
            path: "talentRecruitment",
            name: 'talentRecruitment',
            component: () => import(/* webpackChunkName: "talentRecruitment" */ "@/views/product/talentRecruitment.vue"),
            meta: {
              name: '人才引进'
            }
          },
          // 组织人事
          {
            path: "personnelOrganization",
            name: 'personnelOrganization',
            component: () => import(/* webpackChunkName: "personnelOrganization" */ "@/views/product/personnelOrganization.vue"),
            meta: {
              name: '组织人事'
            }
          },
          // 薪酬保险
          {
            path: "salaryInsurance",
            name: 'salaryInsurance',
            component: () => import(/* webpackChunkName: "salaryInsurance" */ "@/views/product/salaryInsurance.vue"),
            meta: {
              name: '薪酬保险'
            }
          },
          // 经理自助
          {
            path: "managerSelfService",
            name: 'managerSelfService',
            component: () => import(/* webpackChunkName: "managerSelfService" */ "@/views/product/managerSelfService.vue"),
            meta: {
              name: '经理自助'
            }
          },
        ]
      },
      {
        path: "/solution",
        name: 'solution',
        component: () => import(/* webpackChunkName: "solution" */ "@/views/solution/index.vue"),
        children: [
          {
            path: "securityTechnology",
            name: 'securityTechnology',
            component: () => import(/* webpackChunkName: "securityTechnology" */ "@/views/solution/SecurityTechnology.vue"),
            meta: {
              name: '安全与技术解决方案'
            }
          },
          {
            path: "corePersonnel",
            name: 'corePersonnel',
            component: () => import(/* webpackChunkName: "corePersonnel" */ "@/views/solution/CorePersonnel.vue"),
            meta: {
              name: '核心人力资源管理'
            }
          },
          {
            path: "democraticEvaluation",
            name: 'democraticEvaluation',
            component: () => import(/* webpackChunkName: "democraticEvaluation" */ "@/views/solution/DemocraticEvaluation.vue"),
            meta: { name: '民主测评' }
          },
          {
            path: "democraticRecommendation",
            name: 'democraticRecommendation',
            component: () => import(/* webpackChunkName: "democraticRecommendation" */ "@/views/solution/DemocraticRecommendation.vue"),
            meta: { name: '民主推荐' }
          },
          {
            path: "assessment360",
            name: 'assessment360',
            component: () => import(/* webpackChunkName: "assessment360" */ "@/views/solution/Assessment360.vue"),
            meta: { name: '360考核' }
          },
          {
            path: "leadershipAssessment",
            name: 'leadershipAssessment',
            component: () => import(/* webpackChunkName: "leadershipAssessment" */ "@/views/solution/LeadershipAssessment.vue"),
            meta: { name: '领导力评估' }
          },
          {
            path: "peerReview",
            name: 'peerReview',
            component: () => import(/* webpackChunkName: "peerReview" */ "@/views/solution/PeerReview.vue"),
            meta: { name: '同行评议' }
          },
          {
            path: "onlineLearningExam",
            name: 'onlineLearningExam',
            component: () => import(/* webpackChunkName: "onlineLearningExam" */ "@/views/solution/OnlineLearningExam.vue"),
            meta: { name: '在线学习与考试' }
          },
          {
            path: "talentMap",
            name: 'talentMap',
            component: () => import(/* webpackChunkName: "talentMap" */ "@/views/solution/TalentMap.vue"),
            meta: { name: '人才地图' }
          },
          {
            path: "cadreManagement",
            name: 'cadreManagement',
            component: () => import(/* webpackChunkName: "cadreManagement" */ "@/views/solution/CadreManagement.vue"),
            meta: { name: '干部管理' }
          },
          {
            path: "orgPerformance",
            name: 'orgPerformance',
            component: () => import(/* webpackChunkName: "orgPerformance" */ "@/views/solution/OrgPerformance.vue"),
            meta: { name: '组织绩效管理' }
          },
          {
            path: "fullPerformance",
            name: 'fullPerformance',
            component: () => import(/* webpackChunkName: "fullPerformance" */ "@/views/solution/FullPerformance.vue"),
            meta: { name: '全员绩效管理' }
          },
          {
            path: "solutionTitleReview",
            name: 'solutionTitleReview',
            component: () => import(/* webpackChunkName: "solutionTitleReview" */ "@/views/solution/TitleReview.vue"),
            meta: { name: '职称评审' }
          },
          {
            path: "talentProject",
            name: 'talentProject',
            component: () => import(/* webpackChunkName: "talentProject" */ "@/views/solution/TalentProject.vue"),
            meta: { name: '人才项目' }
          },
          {
            path: "talentInventory",
            name: 'talentInventory',
            component: () => import(/* webpackChunkName: "talentInventory" */ "@/views/solution/TalentInventory.vue"),
            meta: { name: '人才盘点' }
          },
          {
            path: "solutionTalentDevelopment",
            name: 'solutionTalentDevelopment',
            component: () => import(/* webpackChunkName: "solutionTalentDevelopment" */ "@/views/solution/SolutionTalentDevelopment.vue"),
            meta: { name: '人才管理' }
          },
          {
            path: "institutionTalent",
            name: 'institutionTalent',
            component: () => import(/* webpackChunkName: "institutionTalent" */ "@/views/solution/InstitutionTalent.vue"),
            meta: { name: '事业单位人才管理' }
          },
          {
            path: "managerTenure",
            name: 'managerTenure',
            component: () => import(/* webpackChunkName: "managerTenure" */ "@/views/solution/ManagerTenure.vue"),
            meta: { name: '经理层任期制考核' }
          }
        ]
      },
      // 解决方案列表
      {
        path: "/productList",
        name: 'productList',
        component: () => import(/* webpackChunkName: "productList" */ "@/views/product/list/ProductList.vue"),
        meta: {
          keepAlive: true
        }
      },
      // 合作伙伴
      {
        path: "/cooperativePartner",
        name: 'cooperativePartner',
        component: () => import(/* webpackChunkName: "cooperativePartner" */ "@/views/partner/CooperativePartner.vue"),
      },
      // 合作伙伴列表
      {
        path: "/partnerList",
        name: 'partnerList',
        component: () => import(/* webpackChunkName: "typicalUsers" */ "@/views/partner/PartnerList.vue")
      },
      // 经典实践
      {
        path: "/typicalUsers",
        name: 'typicalUsers',
        component: () => import(/* webpackChunkName: "typicalUsers" */ "@/views/typicalUsers/TypicalUsers.vue"),
        meta: {
          keepAlive: true
        }
      },
      // 经典实践 - 用户案例
      {
        path: "/typicalUsers/userStories",
        name: 'userStories',
        component: () => import(/* webpackChunkName: "typicalUsers" */ "@/views/typicalUsers/UserStories.vue")
      },
      // 关于我们
      {
        path: "/aboutUs",
        name: 'aboutUs',
        component: () => import(/* webpackChunkName: "aboutUs" */ "@/views/aboutUs/AboutUs.vue")
      },
    ]
  },
  {
    path: '/fullPdf/:pdfName',
    name: 'fullPdf',
    component: () => import(/* webpackChunkName: "fullPdf" */ "@/views/fullPdf.vue")
  },

]
const originalReplace = VueRouter.prototype.replace;
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
}

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL,
  base: '/mh',
  routes
})

router.beforeEach((to, from, next) => {
  warningClose()
  next()
});

router.afterEach((to) => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
  updateShareMeta(to)
});



export default router
